// Lydia Orange Art: confetti when free UK shipping unlocks in the cart.
// Fires when the free-shipping bar turns complete (.lo-ship-bar--done) after a cart update,
// not on a plain page load, and only once until the cart drops back below the threshold.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var colours = ['#bc5631', '#103948', '#e0b060', '#3f7a4a', '#d99bbe', '#6db3b8'];
  var lastFired = null;

  function burst(box) {
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('span');
      var angle = Math.random() * Math.PI * 2;
      var distance = 60 + Math.random() * 110;
      piece.className = 'lo-confetti';
      piece.style.background = colours[i % colours.length];
      piece.style.setProperty('--dx', Math.cos(angle) * distance + 'px');
      piece.style.setProperty('--dy', Math.sin(angle) * distance * 0.7 - 30 + 'px');
      piece.style.setProperty('--rot', Math.random() * 720 - 360 + 'deg');
      piece.style.animationDelay = Math.random() * 120 + 'ms';
      box.appendChild(piece);
      setTimeout(function (el) { el.remove(); }, 1600, piece);
    }
  }

  function check() {
    var boxes = document.querySelectorAll('.lo-ship-bar--done');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (!box.offsetParent) continue; // hidden (e.g. closed drawer)
      var count = box.getAttribute('data-ship-state');
      if (count !== lastFired) { lastFired = count; burst(box); }
      return;
    }
  }

  function start() {
    // remember the state on load so we don't celebrate a cart that was already complete
    var initial = document.querySelector('.lo-ship-bar--done');
    lastFired = initial ? initial.getAttribute('data-ship-state') : null;
    new MutationObserver(function () { setTimeout(check, 350); }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function () { setTimeout(check, 500); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
